import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const SEOMarketingLanding = lazy(() => import("@/pages/SEOMarketingLanding"));

export const Route = createFileRoute("/dinner-with-strangers")({
  component: SEOMarketingLanding,
});
